import { c as _c } from "react/compiler-runtime";
import { useDebounceCallback } from "@opensea/ui-kit/hooks";
import { useSound } from "use-sound";
import { Sound, soundOpts, useVolume } from "@/stores/use-volume-store";
export { Sound };
export function usePlaySound(sound) {
  const $ = _c(8);
  const {
    volume
  } = useVolume();
  let t0;
  if ($[0] !== volume) {
    t0 = soundOpts(volume);
    $[0] = volume;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  const [playSound] = useSound(sound, options);
  let t1;
  if ($[2] !== playSound || $[3] !== volume) {
    t1 = (...t2) => {
      const args = t2;
      if (volume === "off") {
        return Promise.resolve();
      }
      return playSound(...args);
    };
    $[2] = playSound;
    $[3] = volume;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      leading: true,
      trailing: false
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const debouncedPlaySound = useDebounceCallback(t1, 300, t2);
  let t3;
  if ($[6] !== debouncedPlaySound) {
    t3 = [debouncedPlaySound];
    $[6] = debouncedPlaySound;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}